import React from 'react';
import Slider from 'react-slick';
import useValueForCurrentViewPort from '../../helpers/useValueForCurrentViewPort';
import i18next from '../../config/i18next';

import './style.scss';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import {
  Container,
} from '..';


const SliderRelated = ({ children, title, slidesToShow = 3 }) => {
  const centerPadding = useValueForCurrentViewPort('10%', '10%', '10%', '10%', '10%');
  const sliderTitle = title || i18next.t('others_also_viewed');

  /**
   * @example
   * @description A function that returns an arrow to click on for the slider to go left.
   * @returns A div.
   */
  function PrevArrow({ onClick }) {
    return (
      <div
        className="SliderRelated__prev"
        onClick={onClick}
      >
        <div
          className="ParagraphSlider__prev icon-before icon-after icon-arrow-left icon-variant-4 moving-arrow"
          onClick={onClick}
        />
      </div>
    );
  }

  /**
   * @example
   * @description A function that returns an arrow to click on for the slider to go right.
   * @returns A div.
   */
  function NextArrow({ onClick }) {
    return (
      <div
        className="SliderRelated__next"
        onClick={onClick}
      >
        <div
          className="ParagraphSlider__next icon-before icon-after icon-arrow-right icon-variant-4 moving-arrow"
          onClick={onClick}
        />
      </div>
    );
  }

  const settings = {
    infinite: true,
    slidesToShow: slidesToShow,
    slidesToScroll: 3,
    centerMode: true,
    centerPadding: centerPadding,
    speed: 1000,
    autoplay: false,
    autoplaySpeed: 7000,
    pauseOnFocus: true,
    accessibility: true,
    touchMove: false,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  const amountOfItems = children.size;
  const firstChild = children.get(0);
  const lastChild = children.get(amountOfItems - 1);
  const otherChildren = children.slice(1, amountOfItems - 1);

  return (
    <div className="SliderRelated">
      <Container>
        <h2 className="SliderRelated__title">{ sliderTitle }</h2>
      </Container>
      <Slider {...settings}>
        { otherChildren }
        { lastChild }
        { firstChild }
      </Slider>
    </div>
  );
};

export default SliderRelated;
